/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Tab_EmptyInputs */



/**
* | output |
* | --- |
* | "No media versions imported yet." |
*
* @param {Media_Tab_EmptyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_tab_empty = /** @type {((inputs?: Media_Tab_EmptyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Tab_EmptyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune version multimédia n'a encore été importée.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Es wurden noch keine Medienversionen importiert.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessuna versione multimediale è stata ancora importata.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пока не импортированы никакие версии медиафайлов.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aún no se han importado versiones multimedia.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("尚未导入任何媒体版本。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メディアバージョンはまだインポートされていません。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अभी तक कोई मीडिया संस्करण आयात नहीं किया गया है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhuma versão de mídia foi importada ainda.")
	return /** @type {LocalizedString} */ ("No media versions imported yet.")
});